import { createI18n } from '@ngsos/portal-core/i18n';

export const USER_PREFERRED_CULTURE_STORAGE_KEY = 'UserPrefferedCulture';

function readStoredCulture(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(USER_PREFERRED_CULTURE_STORAGE_KEY);
    if (raw === null || raw === '') {
      return null;
    }
    try {
      const parsed: unknown = JSON.parse(raw);
      return typeof parsed === 'string' && parsed !== '' ? parsed : null;
    } catch {
      return raw;
    }
  } catch {
    return null;
  }
}

function persistCultureIfStorageIsWritable(culture: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(USER_PREFERRED_CULTURE_STORAGE_KEY, JSON.stringify(culture));
  } catch {
    return;
  }
}

function detectWebCulture(): string | null {
  const storedCulture = readStoredCulture();
  if (storedCulture !== null) {
    return storedCulture;
  }
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }
  return null;
}

function applyCultureToDocument(culture: string): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = culture;
  }
}

export const { initI18n, changeLanguage } = createI18n({
  detectCulture: detectWebCulture,
  persistCulture: persistCultureIfStorageIsWritable,
  onCultureApplied: applyCultureToDocument,
});
